import React from 'react';
import ExpandIcon from '@atlaskit/icon/glyph/chevron-down';
import Tooltip from '@atlaskit/tooltip';
import Pulse from './pulse';
import { DefaultButton, DoneButton, InProgressButton, ToDoButton } from './styled';
import type { Props } from './types';

const getButton = (categoryId: number) => {
	switch (categoryId) {
		case 2:
			return ToDoButton;
		case 3:
			return DoneButton;
		case 4:
			return InProgressButton;
		default:
			return DefaultButton;
	}
};

export const StatusButton = (props: Props) => {
	const {
		ariaLabel,
		isEditable,
		isOpen,
		status,
		targetRef,
		statusButtonRef,
		shouldFitContainer = true,
	} = props;
	const Button = getButton(status.statusCategory.id);

	return (
		<div ref={targetRef}>
			<Tooltip position="top" content={status.name}>
				<Pulse status={status}>
					<Button
						id="issue.fields.status-view.status-button"
						ref={statusButtonRef}
						aria-label={ariaLabel}
						aria-expanded={isOpen}
						isDisabled={!isEditable}
						iconAfter={<ExpandIcon label="" />}
						testId="issue-field-status.ui.status-view.status-button.status-button"
						shouldFitContainer={shouldFitContainer}
					>
						{status.name}
					</Button>
				</Pulse>
			</Tooltip>
		</div>
	);
};
